// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"4840bb43","186":"bbf2c258","344":"a49d4fac","372":"e00ea4a5","377":"feedf835","738":"e3d8a629","841":"5d84bceb","851":"f8aa8e94","856":"2473d468"}[chunkId] + ".chunk.js";
};